import { render, staticRenderFns } from "./VacationTicketIndex.vue?vue&type=template&id=f5ed97d4&"
import script from "./VacationTicketIndex.vue?vue&type=script&lang=js&"
export * from "./VacationTicketIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports